export const COLOR_WHITE = '#ffffff';
export const COLOR_BLACK = '#000000';
export const DEFAULT_SHADOW_EFFECT = '0 10px 30px rgba(0, 0, 0, .15)';

// header
export const HEADER_LOGO_HEIGHT = 40;

// collectionCard
export const COLLECTION_CARD_BORDER_RADIUS = 10;
export const COLLECTION_CARD_HEADER_SIZE = '20%';

// item summary
export const ITEM_SUMMARY_DESCRIPTION_MIN_HEIGHT = 100;
